import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { CustomerFilterModel, OrderFilterModel, UserServiceProxy } from '../../../../shared/service-proxies/event-service-proxy';
import { DateLocaleService } from '../../../services/date-locale/date-locale.service';
import { takeUntil } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { DestroyService } from '../../../services/destroy/destroy.service';

@Component({
    selector: 'app-filter-order',
    templateUrl: './filter-order.component.html',
    styleUrl: './filter-order.component.scss',
    standalone: false,
    providers: [DestroyService],
})
export class FilterOrderComponent implements OnInit {
  @Input() orderFilter: OrderFilterModel = new OrderFilterModel();
  selectedUsers: string | null = null; 

  optionsUsers: any[] = [];

  dateRange: { startDate: Date; endDate: Date } = { startDate: null, endDate: null };

  constructor(private destroyService: DestroyService, public dateLocaleService: DateLocaleService, private authService: AuthService, private _userService: UserServiceProxy) {}

  ngOnInit(): void {
    this.initializeFilters();
    this.getUser();
  }

 initializeFilters() {
    if (!this.orderFilter.totalFrom) {
      this.orderFilter.totalFrom = 0;
    }
    if (!this.orderFilter.totalTo) {
      this.orderFilter.totalTo = 2050;
    }
   
   this.dateRange = { startDate: this.orderFilter.createdFrom, endDate: this.orderFilter.createdTo };
  }

  onDateChange(event: { startDate: Date; endDate: Date }) {
    this.orderFilter.createdFrom = event.startDate || undefined;
    this.orderFilter.createdTo = event.endDate || undefined;
  }

  getUser() {
    this._userService.getUsers(this.authService.getCompanyId())
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(res => {
         this.optionsUsers = res.map(r => ({ id: r.id, name: r.firstname + ' ' + r.lastname })); 
      })
  }
  onSelectChange(selected: string | null = null, filterArray: string = '') {
    if (!selected) {
      this.orderFilter[filterArray] = [];
      return;
    }
    if (!this.orderFilter[filterArray]) {
      this.orderFilter[filterArray] = [];
    }
    
    this.orderFilter[filterArray].push(selected);
  }

}
